<template>
  <v-container>
    <h1 class="display-3">Logout</h1>
    <p>Signing out...</p>
  </v-container>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>

</style>